import Hashids from 'hashids'

/**
 * Matches `Offer.hash_from_artkey` / `encode_value` in `common_lib/core_models/hash.py`
 * (Hashids with default salt, min length 6).
 */
const offer_hashids = new Hashids('', 6)

export function offer_hash_from_artkey(artkey: number): string {
    return offer_hashids.encode(artkey)
}
